"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITLEMENTS_REDUCER_KEY = void 0;
const redux_actions_1 = require("redux-actions");
const luxon_1 = require("luxon");
const core_1 = require("companion-app-components/utils/core");
const core_2 = require("companion-app-components/flux/core");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const entitlementsTypes_1 = require("companion-app-components/flux/entitlements/entitlementsTypes");
const actions_1 = require("data/app/actions");
const actions = __importStar(require("data/entitlements/entitlementsActions"));
const entitlementsUtils_1 = require("./entitlementsUtils");
const savedStore = (0, entitlementsUtils_1.loadEntitlements)();
const entitlementsLocalReducer = (0, redux_actions_1.handleActions)({
    [entitlements_1.entitlementsActions.getEntitlementsSuccess.type]: (state, { payload }) => {
        let entitlements = payload.resources;
        ////////////////////////////////////////////////////////////////////////////////////////
        const entitlementsOverrideEntries = Object.entries(core_1.localPreferences.getItem('entitlementsOverride') || {});
        entitlements = entitlements.map((entitlement) => {
            const entitlementOverrideEntry = entitlementsOverrideEntries.find(([key]) => key === entitlement.id);
            const valueOverride = entitlementOverrideEntry ? entitlementOverrideEntry[1] : undefined;
            return entitlementOverrideEntry ?
                entitlement.merge({
                    active: Boolean(valueOverride),
                    expiresOn: (valueOverride ? luxon_1.DateTime.local().plus({ years: 1 }).toISODate() : luxon_1.DateTime.local().toISODate()) || undefined,
                    expiresAt: (valueOverride ? luxon_1.DateTime.local().plus({ years: 1 }).toISO() : luxon_1.DateTime.local().toISO()) || undefined,
                }) : entitlement;
        });
        entitlementsOverrideEntries
            .filter(([key]) => !entitlements.find((entitlement) => entitlement.id === key))
            .forEach(([key, value]) => entitlements.push((0, entitlementsTypes_1.mkEntitlement)({
            id: key,
            active: Boolean(value),
            expiresOn: (value ? luxon_1.DateTime.local().plus({ years: 1 }).toISODate() : luxon_1.DateTime.local().toISODate()) || undefined,
            expiresAt: (value ? luxon_1.DateTime.local().plus({ years: 1 }).toISO() : luxon_1.DateTime.local().toISO()) || undefined,
        })));
        ///////////////
        const newState = core_2.resourceUpserters.upsertResources(state, payload.merge({ resources: entitlements, replaceCollection: true }));
        (0, entitlementsUtils_1.saveEntitlements)(newState);
        return newState;
    },
    [entitlements_1.entitlementsActions.getEntitlementsFailure.type]: (state, { payload: error, asyncDispatch }) => {
        if (error.message !== 'sandbox'
            && error.message !== 'offline'
            && error.message !== 'valid auth tokens not found locally') {
            (0, entitlementsUtils_1.clearEntitlements)();
            asyncDispatch((0, actions_1.appHistoryPush)({ location: '/fetch-subscription' }));
        }
        return core_2.resourceUpserters.completeWithError(state, error);
    },
    ////////////////////////////////////////////////////////////////////////////////////
    [actions.setEntitlement.type]: (state, { payload }) => {
        const newState = core_2.resourceUpserters.upsertResource(state, payload);
        (0, entitlementsUtils_1.saveEntitlements)(newState);
        return newState;
    },
    ///////////
}, core_2.resourceStoreTypes.mkQcsSyncResourceStore(savedStore));
exports.ENTITLEMENTS_REDUCER_KEY = entitlementsTypes_1.ENTITLEMENTS_REDUCER_KEY;
const entitlementsCombinedReducer = (state, action) => {
    const intermediateState = entitlementsLocalReducer(state, action);
    return (0, entitlements_1.entitlementsReducer)(intermediateState, action);
};
exports.default = entitlementsCombinedReducer;
